import API from 'src/api'
import { http } from '../boot/axios'

export default {
  GRAPHQL_URL: API.GRAPHQL_URL + 'assignments',

  getAssignedForms () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/forms`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  getLocationsForAssignment (options) {
    let geolocation = false
    if (options.lat && options.long) {
      geolocation = true
    }
    const query = !geolocation ? options.form_assignment_role_id : `${options.form_assignment_role_id}?lat=${options.lat}&long=${options.long}`
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  getCurrentOccurrence (form_assignment_role_id, location_id, routineContext = null) {
    return new Promise((resolve, reject) => {
      const url = `${this.GRAPHQL_URL}/${form_assignment_role_id}/${location_id}`
      const config = routineContext ? { params: routineContext } : {}

      http.get(url, config)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  assignmentEmailRol (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}/assignmentEmailRol/`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchAssignmentRoles (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}/fetchAssignmentRoles/${payload.id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
